

import Main from "../views/main";

const aiFriendStatRoute = {
  path: "/ai-friend-stat",
  component: Main,
  title: "AI女友统计",
  icon: "el-icon-s-custom",
  meta: { keepAlive: true },
  children: [
    {
      path: "/ai-friend-app-stat",
      component: () => import("@/views/aiFriendStat/stat/app"),
      name: "AiFriendAppStat",
      title: "每日App汇总",
      meta: { title: "每日App汇总", keepAlive: true },
    },
    {
      path: "/ai-friend-model-stat",
      component: () => import("@/views/aiFriendStat/stat/model"),
      name: "AiFriendModelStat",
      title: "每日模型汇总",
      meta: { title: "每日模型汇总", keepAlive: true },
    },
    {
      path: "/ai-friend-role-stat",
      component: () => import("@/views/aiFriendStat/stat/role"),
      name: "AiFriendRoleStat",
      title: "每日角色汇总",
      meta: { title: "每日角色汇总", keepAlive: true },
    },
    {
      path: "/ai-friend-app-realtime",
      component: () => import("@/views/aiFriendStat/realtime/app"),
      name: "AiFriendAppRealtime",
      title: "实时App统计",
      meta: { title: "实时App统计", keepAlive: true },
    },
    {
      path: "/ai-friend-model-realtime",
      component: () => import("@/views/aiFriendStat/realtime/model"),
      name: "AiFriendModelRealtime",
      title: "实时模型统计",
      meta: { title: "实时模型统计", keepAlive: true },
    },
    {
      path: "/ai-friend-role-realtime",
      component: () => import("@/views/aiFriendStat/realtime/role"),
      name: "AiFriendRoleRealtime",
      title: "实时角色统计",
      meta: { title: "实时角色统计", keepAlive: true },
    },
    {
      path: "/ai-friend-app-chart",
      component: () => import("@/views/aiFriendStat/charts/app"),
      name: "AiFriendAppChart",
      title: "实时App统计图表",
      meta: { title: "实时App统计图表", keepAlive: true },
    },
    {
      path: "/ai-friend-model-chart",
      component: () => import("@/views/aiFriendStat/charts/model"),
      name: "AiFriendModelChart",
      title: "实时模型统计图表",
      meta: { title: "实时模型统计图表", keepAlive: true },
    },
    {
      path: "/ai-friend-role-chart",
      component: () => import("@/views/aiFriendStat/charts/role"),
      name: "AiFriendRoleChart",
      title: "实时角色统计图表",
      meta: { title: "实时角色统计图表", keepAlive: true },
    },
  ],
};
export default aiFriendStatRoute;
